import axios from "axios";

const BASE_URL = process.env.REACT_APP_EMAIL_API_BASE_URL;

export default axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json"
  }
});